import Provider from "./Provider";

export type { IProviderProps } from "./Provider";

export default Provider;
